<style>
	/* These classes are only needed because the
      drawer is in a container on the page. */
	.drawer-container {
		position: relative;
		display: flex;
		height: 650px;
		overflow: hidden;
		z-index: 0;
	}

	* :global(.app-content) {
		flex: auto;
		overflow: auto;
		position: relative;
		flex-grow: 1;
	}

	.main-content {
		overflow: auto;
		padding: 16px;
		height: 100%;
		box-sizing: border-box;
	}
</style>

<script lang="ts">
	import Drawer, { AppContent, Content } from '@smui/drawer';
	import List, { Item, Text } from '@smui/list';
	import FieldLoading from './FieldLoading.svelte';
	import HorizontalFieldsLoading from './HorizontalFieldsLoading.svelte';
</script>

<div class="drawer-container">
	<Drawer>
		<Content>
			<List>
				{#each { length: 5 } as _}
					<Item class="animate-pulse bg-gray-200" />
				{/each}
			</List>
		</Content>
	</Drawer>

	<AppContent class="app-content">
		<main class="main-content">
			<HorizontalFieldsLoading />
			<FieldLoading />
			<FieldLoading />
		</main>
	</AppContent>
</div>
